import { axiosV1 } from 'interceptors/axios';
import { Dispatch } from 'redux';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

export type SaveDocumentTagsSources = {
  society?: string;
  partner?: string;
  allPartners?: boolean;
  sharesTitle?: string;
  fiscalYear?: number;
  variant?: string;
  referenceDate?: string;
};

type SaveDocumentTags = {
  documentId: string;
  sources: SaveDocumentTagsSources;
  language: string;
};

export const saveDocumentTags =
  ({ documentId, sources, language }: SaveDocumentTags) =>
  async (dispatch: Dispatch) => {
    try {
      const body = { documentId, ...sources, language };
      const { data } = await axiosV1.post('/documents/save-tags', body);

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
